<!--
    @不参与审核的领导-日历组件
-->
<template>
	<el-calendar v-model="value" class="calendar_data">
		<!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
		<template slot="dateCell" slot-scope="{date,data}">
			<p :class="data.isSelected ? 'is-selected' : ''" slot="reference" :data-type="date" @click="calendarOnClick(data)">
				{{data.day.split('-').slice(1)[1]}}
				<span v-if="handleSelected(data.day)"></span>
			</p>
			<!-- <el-popover placement="top-start" width="200" trigger="click">
				<p :class="data.isSelected ? 'is-selected' : ''" slot="reference" :data-type="date" @click="calendarOnClick(data)">
					{{data.day.split('-').slice(1)[1]}}
					<span v-if="handleSelected(data.day)"></span>
				</p>
			</el-popover> -->
		</template>
	</el-calendar>
</template>

<script>
import {timeTrasnform} from '@/utils/index';
import {apiwbschedulemanagementgetManagementBymonth} from '@/server/home-leader';

export default {
	data(){
		return {
			value: new Date(),//日历
			calendarData:[],
			disabled:false
		}
	},
	created(){
		// this.apiwbschedulemanagementgetManagementBymonth(timeTrasnform(this.value,'YYYY-MM'));
		// this.$nextTick(()=>{
		// 	// 点击前一个月
		// 	let prevBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(1)");
		// 	prevBtn.addEventListener("click",e=>{
		// 		this.apiwbschedulemanagementgetManagementBymonth(timeTrasnform(this.value,'YYYY-MM'))
		// 	})
		// 	//点击下一个月
		// 	let nextBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(3)");
		// 	nextBtn.addEventListener("click", () => {
		// 		this.apiwbschedulemanagementgetManagementBymonth(timeTrasnform(this.value,'YYYY-MM'))
		// 	});
		// 	//点击今天
		// 	let todayBtn = document.querySelector(".el-calendar__button-group .el-button-group>button:nth-child(2)");
		// 	todayBtn.addEventListener("click", () => {
		// 		this.apiwbschedulemanagementgetManagementBymonth(timeTrasnform(this.value,'YYYY-MM'))
		// 	});
		// })
	},
	methods:{
		// 获取数据
		apiwbschedulemanagementgetManagementBymonth(time){
			let tempList=[];
			apiwbschedulemanagementgetManagementBymonth(time).then((res)=>{
				const {data} = res;
				if(data.code=='1'){
					data.data.forEach((item1,index1)=>{
						if(item1.dateList&&item1.dateList.length>0){
							item1.dateList.forEach((item2,index2)=>{
								let tempObj={
									time:item2.split(' ')[0],
									option:item1
								}
								tempList.push(tempObj)
							})
						}
					})
					this.calendarData=this.deWeight(tempList);
				}
			})
		},
		// es6的Map()，去重arr3
		deWeight(arr){
			let map = new Map();
			for (let item of arr) {
				if (!map.has(item.time)) {
					map.set(item.time, item);
				}
			}
			return [...map.values()];
		},
		handleConetent(day){
			this.calendarData.forEach((item)=>{
				if(item.time==day){
					return `标题：`;
				}
			})
		},
		// 处理小黄点的显隐
		handleSelected(day){
			let flag=false;
			this.calendarData.forEach((item)=>{
				if(item.time==day){
					flag=true;
					return;
				}
			})
			return flag;
		},
		// 当前日期点击事件
		calendarOnClick(e){
			// console.log(e)
		},
	}
}
</script>

<style lang="less" scoped>
.calendar_data{
	width: 325px;
	margin: 0 auto;
	overflow: auto;
	height: 330px;
	/deep/ .el-calendar__body{
		padding: 0 20px;
		// .el-calendar-table{
		// 	td{
		// 		border-bottom: 0;
		// 		border-right: 0;
		// 	}
		// 	tr td:first-child{
		// 		border-left: 0;
		// 	}
		// 	tr:first-child td{
		// 		border-top: 0;
		// 	}
		// }
		.el-calendar-table__row{
			.el-calendar-day{
				width: 40px;
				height: 38px;
				line-height: 38px;
				text-align: center;
				padding: 0;
				p{
					height: 100%;
					text-align: center;
					position: relative;
					&:focus{
						outline: none;
					}
					span{
						display: block;
						width: 5px;
						height: 5px;
						background: #FEC618;
						border-radius: 50%;
						position: absolute;
						left: 50%;
						bottom: 3px;
						transform: translate(-50%,0);
					}
				}
			}
		}
		.is-selected {
			color: #1989FA;
		}
	}
}
</style>
